import React, { Fragment } from "react";
import {
  Aside,
  Copy,
  Hero,
  SectionFull,
  Sidebar,
  Heading,
  HeadingLines,
} from "@website2018/da-dobsonville";
import { Helmet } from "react-helmet-async";
import { decode } from "he";
import SearchContainer from "../../containers/Data/SearchContainer";

const QuestionsTemplate = (props) => {
  const { page: p, questions } = props;

  const refinements = [
    {
      title: "Category",
      attribute: "taxonomies.question_category",
    },
    {
      title: "Municipality",
      attribute: "taxonomies.municipality",
    },
  ];

  return (
    <Fragment>
      <Helmet
        defaultTitle={decode(
          p.seo.title !== "" ? p.seo.title : p.title.rendered
        )}
        meta={[
          {
            name: "description",
            content:
              p.seo.metadesc !== "" ? p.seo.metadesc : p.excerpt.rendered,
          },
          {
            name: "og:title",
            content:
              p.seo["opengraph-title"] !== ""
                ? p.seo["opengraph-title"]
                : p.title.rendered,
          },
          {
            name: "og:description",
            content:
              p.seo["opengraph-description"] !== ""
                ? p.seo["opengraph-description"]
                : p.excerpt.rendered,
          },
          { name: "og:url", content: `` },
          { name: "og:site_name", content: `Democratic Alliance` },
          { name: "og:type", content: `business` },
          { name: "og:image", content: p.seo["opengraph-image"] || null },
          { name: "fb:app_id", content: "1262049647255981" },
          { name: "twitter:card", content: "”summary_large_image”" },
          { name: "twitter:site", content: "@our_da" },
          {
            name: "twitter:title",
            content:
              p.seo["twitter-title"] !== ""
                ? p.seo["twitter-title"]
                : p.title.rendered,
          },
          {
            name: "twitter:description",
            content:
              p.seo["twitter-description"] !== ""
                ? p.seo["twitter-description”"]
                : p.excerpt.rendered,
          },
          {
            name: "twitter:image",
            content:
              p.seo["twitter-image"] !== "" ? p.seo["twitter-image"] : null,
          },
        ]}
        htmlAttributes={{ lang: "en" }}
      />
      <Hero
        imageUrl={
          p.hero && p.hero.background_image ? p.hero.background_image.url : null
        }
        title={p.hero && p.hero.headline ? p.hero.headline : p.title.rendered}
      />
      {p.content.rendered && (
        <SectionFull mt={"none"} mb="none">
          {/* <div className={"col-lg-7"}> */}
            <Copy intro html={p.content.rendered} />
          {/* </div> */}
          {/* <Sidebar>
            <Aside
              title="Want to ask a question or report a concern in your area?"
              paragraph="<p>You can get in touch with us at GPComplaints@da.org.za.</p>"
              url="mailto:GPComplaints@da.org.za"
              cta="Email us now"
              vertical
              horizontal={false}
              small={false}
            ></Aside>
          </Sidebar> */}
        </SectionFull>
      )}
      <SectionFull mt={"none"} mb="none">
        <HeadingLines lineLeft color={"red"} mb={"medium"}>
          <Heading
            color={"red"}
            tracking={"huge"}
            size={"tiny"}
            weight={"regular"}
            uppercase
          >
            Questions
          </Heading>
        </HeadingLines>
        <SearchContainer
          showTitle={false}
          type="posts"
          postType="Questions"
          refinements={refinements}
          defaultRefinement={{
            attribute: "post_type_label",
            value: "Questions",
          }}
          {...props}
        />
      </SectionFull>
    </Fragment>
  );
};

export default QuestionsTemplate;
